export const GameApplicationType = {
  Web: 'web',
  Mobile: 'mobile',
};
